/**
 * @file   : FastFacts.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:18:24 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import BoxContainer from '../../../external/components/container/BoxContainer'
import ACol from '../../../external/components/layout/ACol'
import AGrid from '../../../external/components/layout/AGrid'
import ARow from '../../../external/components/layout/ARow'
import Cont, {
  ALIGN_CENTER,
  TEXT_ALIGN_CENTER,
} from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import AImg from '../../../external/components/media/img/AImg'
import TextStyler, {
  GREY_TEXT,
} from '../../../external/components/text/TextStyler'
import { getTranslation, isData } from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionHeader from './SectionHeader'

const FastFacts = ({ intl, theme, section, infoData, mainConfig }) => {
  const getFastFact = function (fastFact) {
    const imgDesc = getTranslation(
      intl,
      fastFact.imageDescription.token,
      fastFact.imageDescription.default,
      infoData.infoToken,
    )

    return (
      <Cont>
        <Cont align={ALIGN_CENTER}>
          <AImg
            imageURL={fastFact.imageURL}
            cmpLabel={imgDesc}
            cmpTitle={imgDesc}
            responsive
          ></AImg>
        </Cont>
        <Cont textAlign={TEXT_ALIGN_CENTER}>
          <TextStyler styleObj={{ ...GREY_TEXT }}>
            {getTranslation(
              intl,
              fastFact.token,
              fastFact.default,
              infoData.infoToken,
            )}
          </TextStyler>
        </Cont>
      </Cont>
    )
  }

  if (isData(section) && section.showSection) {
    return (
      <Cont>
        <BoxContainer borderColor={'grey-medium'}>
          <SectionHeader intl={intl} section={section} infoData={infoData} />
          <AGrid fluid>
            <ARow>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[0])}
                <Cont hideLG>
                  <Section />
                </Cont>
              </ACol>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[1])}
                <Cont hideLG>
                  <Section />
                </Cont>
              </ACol>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[2])}
                <Cont hideLG>
                  <Section />
                </Cont>
              </ACol>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[3])}
                <Cont hideLG hideMD>
                  <Section />
                </Cont>
              </ACol>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[4])}
                <Cont hideLG hideMD hideSM>
                  <Section />
                </Cont>
              </ACol>
              <ACol xs={12} sm={6} md={4} lg={2}>
                {getFastFact(section.content[5])}
              </ACol>
            </ARow>
          </AGrid>
        </BoxContainer>
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </Cont>
    )
  }

  return null
}

FastFacts.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default FastFacts
